import styled from 'styled-components';
import { PriceVatExcludedTemplate } from './PriceVatExcludedTemplate';
export const PriceVatExcludedStyled = styled(PriceVatExcludedTemplate)`
    .currencyLabel__suffix--OTR {
        display: inherit;
    }
`;
